import React, { Fragment, useEffect } from 'react';
import { Link } from 'react-scroll';
import Head from 'next/head';
import cn from 'classnames';

import Footer from './Footer';
import styles from './styles/BrandPages.module.scss';

/**
 * Terms component
 * @param {*} props
 */
export default function Terms() {
  useEffect(() => {
    const elm = document.querySelector('#content-section');
    const handleScroll = () => {
      const topSection = document.querySelector('#ictlife-philosophy');
      const topSectionOffset = topSection.offsetTop;
      const elmOffsetTop = elm.scrollTop;
      const offsetDifference = topSectionOffset - elmOffsetTop;

      const navElement = document.querySelector('#nav-holder');

      if (offsetDifference < 1) {
        if (navElement.style.position === '') {
          navElement.style.position = 'fixed';
          navElement.style.width = '23%';
          navElement.style.top = '5.1em';
          navElement.style.height = 'calc(100vh - 5.1em)';
        }
      } else {
        if (navElement.style.position === 'fixed') {
          navElement.style.position = '';
          navElement.style.width = 'unset';
          navElement.style.top = 'unset';
          navElement.style.height = 'unset';
        }
      }
    };
    elm && elm.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      elm && elm.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Fragment>
      <Head>
        <meta
          name="description"
          content="Ideas Come To Life Ltd, or ICTLife (“us”, “we”), is a technology company building
           services and products to enable “A Prosperous Africa”. We aim to do this through building
            technology infrastructure and related applications and platforms that unlock the potential
             of better commerce across our economies. We would like to fulfil this mission while respecting
              our customers’ fundamental rights, such as privacy, and remaining transparent and straight-forth
               in our guiding principles and business 
          practices. Our aim therefore with these terms and conditions (may also be referred to as “general terms and conditions”)
           is to set the common ground that guides our association with you (the user of our services and products)
            and to create a sense of clarity and understanding between us and our customers. These terms and
             conditions will govern the relationship between us and a user of the ICTLife Merchant mobile
              Application(“the Merchant App”, or simply “the App”) and the companion websites
               ( collectively these are hereinafter referred to as the “ICTLife Merchant platform”
                 or the “Merchant platform”, or simply the “platform”)."
        />
        <meta
          property="og:description"
          content="Ideas Come To Life Ltd, or ICTLife (“us”, “we”), is a technology company building
           services and products to enable “A Prosperous Africa”. We aim to do this through building
            technology infrastructure and related applications and platforms that unlock the potential
             of better commerce across our economies. We would like to fulfil this mission while respecting
              our customers’ fundamental rights, such as privacy, and remaining transparent and straight-forth
               in our guiding principles and business 
          practices. Our aim therefore with these terms and conditions (may also be referred to as “general terms and conditions”)
           is to set the common ground that guides our association with you (the user of our services and products)
            and to create a sense of clarity and understanding between us and our customers. These terms and
             conditions will govern the relationship between us and a user of the ICTLife Merchant mobile
              Application(“the Merchant App”, or simply “the App”) and the companion websites
               ( collectively these are hereinafter referred to as the “ICTLife Merchant platform”
                 or the “Merchant platform”, or simply the “platform”)."
        />
      </Head>
      <div className={cn(styles.backgroundTitle, 'theme-background')}>
        <h1>Terms &amp; Conditions of Use</h1>
      </div>
      <div className={cn(styles.sectionContent, 'content-placeholder')}>
        <div className={styles.termsHolder}>
          <div className={styles.navigation}>
            <div className={styles.navHolder} id="nav-holder">
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="ictlife-philosophy"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  The ICTLife Philosophy
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="basis-for-terms-and-conditions"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  The basis for these terms and conditions
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="accessing-ictlife-merchant-platform"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Accessing the ICTLife Merchant platform
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="intellectual-property-rights"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Intellectual property rights on the ICTLife Merchant platform
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="usage-and-interaction"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Usage and Interaction on the ICTLife Merchant platform
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="usage-of-merchant-platform-website"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Usage of ICTLife Merchant platform website(s)
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="general-prohibitions"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  General prohibitions
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="grant-of-rights"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Your grant of rights to ICTLife to use your content
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="community-interaction-guidelines"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Community Interaction guidelines
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="continuous-improvement-updates-and-upgrades"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Continuous improvement, updates and upgrades
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="our-standpoint-on-data-privacy"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Our standpoint on Data Privacy
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="due-diligence-and-audit-rights"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Due diligence and audit rights
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="our-responsibility-as-provider-of-merchant-platform"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Our responsibility as the provider of the Merchant platform
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="disclaimer-of-warranties-and-limitation-of-liability"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Disclaimer of warranties and limitation of liability
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="indemnification"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Indemnification
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="discontinuation-of-this-agreement"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Discontinuation of this agreement
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="severability-of-provisions-in-these-terms-and-conditions"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Severability of provisions in these terms and conditions
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="transfer-of-rights-or-assignment"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Transfer of rights/Assignment
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="third-party-rights-and-consent"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Third party rights and consent
                </Link>
              </div>
              <div className={styles.link}>
                <Link
                  activeClass="theme-text"
                  to="resolution-of-disputes-and-applicable-law"
                  spy={true}
                  smooth={true}
                  hashSpy={true}
                  duration={500}
                  containerId="content-section"
                >
                  Resolution of disputes and applicable law
                </Link>
              </div>
            </div>
          </div>
          <div className={styles.termsContent} id="terms-content">
            <div className={styles.subSection} id="ictlife-philosophy">
              <h1>The ICTLife Philosophy</h1>
              <p>
                Ideas Come To Life Ltd, or ICTLife (“us”, “we”), is a technology
                company building services and products to enable “A Prosperous
                Africa”. We aim to do this through building technology
                infrastructure and related applications and platforms that
                unlock the potential of better commerce across our economies.
              </p>
              <p>
                We would like to fulfil this mission while respecting our
                customers’ fundamental rights, such as privacy, and remaining
                transparent and straight-forth in our guiding principles and
                business practices.
              </p>
              <p>
                Our aim therefore with these terms and conditions (may also be
                referred to as “general terms and conditions”) is to set the
                common ground that guides our association with you (the user of
                our services and products) and to create a sense of clarity and
                understanding between us and our customers.
              </p>
              <p>
                These terms and conditions will govern the relationship between
                us and a user of the ICTLife Merchant mobile Application(“the
                Merchant App”, or simply “the App”) and the companion websites (
                collectively these are hereinafter referred to as the “ICTLife
                Merchant platform” or the “Merchant platform”, or simply the
                “platform”).
              </p>
            </div>
            <div
              className={styles.subSection}
              id="basis-for-terms-and-conditions"
            >
              <h1>The basis for these terms and conditions</h1>
              <p>
                While we endeavor to facilitate open business practices and
                accessible technology, we are still subject to legal and
                regulatory requirements within the jurisdictions where we
                operate. We therefore would like to safeguard the interests of
                our customers while also remaining compliant with such
                regulatory obligations. We also advocate for the openness and
                clarity of our business policies to our customers and we hope to
                set up the foundation here.
              </p>
              <p>
                As well, it is important to bear in mind that we invest
                ourselves in developing the technology and related intellectual
                property, and that we must therefore provide our services and
                products while safeguarding our rights to such properties and
                ensure that our efforts bear the intended service and utility to
                our customers.
              </p>
              <p>
                We would also like to foster an open and trust-driven Merchant
                platform with smooth and respectful interaction amongst our
                users in order to create a prosperous and economically
                progressive ecosystem with minimum conflict and dispute.
              </p>
            </div>
            <div
              className={styles.subSection}
              id="accessing-ictlife-merchant-platform"
            >
              <h1>Accessing the ICTLife Merchant platform</h1>
              <p>
                You can access the ICTLife main website at{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.ictlife.com"
                >
                  https://www.ictlife.com.
                </a>{' '}
                The website will contain links to the ICTLife Merchant platform,
                including the Merchant App and its companion website (which you
                may also access directly at{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={process.env.NEXT_PUBLIC_MERCHANT_WEB_URL}
                >
                  {process.env.NEXT_PUBLIC_MERCHANT_WEB_URL}
                </a>{' '}
                or the current address at your time of access). Links to the App
                may also point you to our published sources (commonly referred
                to as “stores”, such as the Google Play store, the Apple App
                store, etc) from where you can download and install the Merchant
                App onto your device.
              </p>
              <p>
                You agree that, upon downloading the App from such a third party
                store, you will be bound by the specific terms and conditions
                that govern the use of such store.
              </p>
              <p>
                Your access and interaction with the Merchant platform will
                constitute your full agreement with these general terms and
                conditions henceforth unless terminated as per the provisions
                herein.
              </p>
            </div>
            <div
              className={styles.subSection}
              id="intellectual-property-rights"
            >
              <h1>
                Intellectual property rights on the ICTLife Merchant platform
              </h1>
              <p>
                For the correct operation of the ICTLife Merchant App, you are
                entitled to download and use only a single copy of the App for
                each mobile device.
              </p>
              <h3>
                Subject to the express provisions of these terms and conditions:
              </h3>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    ICTLife, together with any of our licensors, own and control
                    all the copyright and other intellectual property rights in
                    the ICTLife merchant platform;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    All the copyright and other intellectual property rights on
                    the ICTLife Merchant platform are reserved;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    The ICTLife logo, related logos and our other registered and
                    unregistered trademarks are owned by us; we give no
                    permission for the unauthorized use of these trademarks, and
                    such use may constitute an infringement of our rights.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    We may charge you a license fee for the use of the ICTLife
                    Merchant platform, which we solely will determine depending
                    on the intended duration of use of the platform, or based on
                    any other criteria as we may deem fit, including but not
                    limited to your desired use of certain premium components or
                    features and other exclusive functionality. We shall clearly
                    communicate such fees where applicable through appropriate
                    channels such as the App download page, a companion website
                    of the App, our main website and in-App notifications
                    amongst others.
                    <br />
                    <br />
                    Please note that mobile service provider charges, such as
                    your internet connectivity data fees are not inclusive in
                    any license fees we may charge you for usage of the platform
                    and you will therefore be required to bear such costs
                    separately based on your agreement with your mobile service
                    provider;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    Once these terms and conditions come into effect (as
                    outlined above), and upon your payment of the license fee to
                    us, if so required, we shall grant you an exclusive,
                    non-transferable and non-assignable license for the duration
                    of your use of the ICTLife Merchant platform and only for
                    your personal or business use of the platform.
                  </div>
                </div>
              </div>
              <h3>You agree:</h3>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    not to adapt, translate, modify, enhance, recompile,
                    decompile or reverse-compile, including binary-editing, or
                    otherwise reverse-engineer the ICTLife Merchant platform or
                    any of its components;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    not to merge, interface, combine the whole or part of the
                    ICTLife Merchant platform or any source code or similar
                    derivatives of the platform including any associated
                    documentation without our prior written consent;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    that any part of the ICTLife Merchant platform which is
                    derived from open source components may only be used in
                    accordance with the applicable license terms of such
                    components;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    not to use the ICTLife Merchant platform on behalf of or
                    download it for/to, or make it available to third-parties in
                    exchange for a fee without our express written consent;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    not to charge or receive any fees or commissions whatsoever
                    from a third party for any services rendered through your
                    direct use of the ICTLife Merchant platform where such
                    service would be directly available to such third parties
                    should they independently install and use their own copy of
                    the App;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    to use the ICTLife Merchant platform within the local and
                    international legal and regulatory restrictions that apply
                    to you. You commit not to use the platform for criminal,
                    fraudulent or other illegal purposes.
                  </div>
                </div>
              </div>
              <div>
                The third party registered and unregistered trademarks or
                service marks on the ICTLife Merchant platform, including
                copyrighted content, are the intellectual property of their
                respective owners and we do not endorse, neither are we
                affiliated with any of the holders of such rights, and as such
                we cannot grant any license to exercise those rights. Your usage
                of the Merchant platform does not imply or grant you any rights
                to such intellectual property; such can only be granted by the
                respective owners.
              </div>
              <h3>For clarity and the avoidance of doubt :</h3>
              <div>
                ICTLife does not transfer any title or ownership of the ICTLife
                Merchant platform and any of its components to you and we
                reserve any and all rights that are not expressly granted to
                you.
              </div>
            </div>
            <div className={styles.subSection} id="usage-and-interaction">
              <h1>Usage and Interaction on the ICTLife Merchant platform</h1>
              <h3>Account Setup and registration</h3>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    You can access the ICTLife Merchant platform as provided in
                    the “Accessing the ICTLife Merchant platform” section above.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    You must have attained the legal adult age in your
                    jurisdiction/country (commonly 18 years) to qualify to use
                    the ICTLife Merchant platform. We may also require that you
                    register for an account with us for the purposes of using
                    the platform and/or any related services that we offer to
                    our customers.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    You may register for an account by completing the account
                    registration process on the ICTLife Merchant platform. You
                    represent and warrant that all information submitted as part
                    of the registration process, including all subsequent
                    updates or modifications, is complete and accurate.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    If we permit the registration of your account on the ICTLIfe
                    Merchant platform, it will remain open indefinitely, subject
                    to these terms and conditions and any of their updates as we
                    may make from time to time.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    You understand and agree that by registering an account on
                    the ICTLife Merchant platform, no legal partnership or
                    agency relationship is created between you and ICTLife. You
                    agree not to represent otherwise without our expressly
                    granted permission.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    We will require that you access and maintain a logged-in
                    session with your account through the provided
                    authentication and authorization procedures to access any
                    services or sections of the Merchant platform that require
                    an account. We may invalidate such login sessions and force
                    the re-authentication of existing sessions should we
                    determine, in our sole discretion, any suspicious or
                    otherwise potentially dangerous or unwanted activity on your
                    account.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    <p>
                      If you set up an account for use in the course of a
                      business or other organizational or similar project, then
                      you:
                    </p>

                    <div className={styles.romanList}>
                      <div>
                        i) pledge that this is a bona-fide business or project
                        that is legal and adheres to the local and international
                        laws i.e. it is not an illegal business.
                      </div>
                      <div>
                        ii) pledge that you have any required licenses and have
                        met any other requirements imposed on your type of
                        business by the jurisdiction in which you operate it.
                      </div>
                      <div>
                        iii) pledge that this is not a fraud or scam, or sale of
                        any illegal goods or services
                      </div>
                      <div>
                        iv) bind both yourself and the person, company or other
                        legal entity that operates that business or
                        organizational project, to these general terms and
                        conditions; and
                      </div>
                      <div>
                        v) agree that “you” in these terms and conditions shall
                        reference both the individual user and the relevant
                        person, company or legal entity unless the context
                        explicitly requires otherwise.
                      </div>
                      <div>
                        vi) confirm that you have obtained the necessary
                        authority to agree to these terms and conditions;
                      </div>
                      <div>
                        vii) confirm that you have obtained the necessary
                        authority to submit onto the ICTLife platform any
                        material that may be subject to the intellectual
                        property rights of such business or organization;
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    <p>
                      Unless you own or control the relevant rights in all the
                      material (or have obtained the necessary authority to do
                      so), you must not:
                    </p>
                    <div className={styles.romanList}>
                      <div>
                        i) post or otherwise publish material onto the ICTLife
                        Merchant platform through the ICTLife Merchant App, a
                        companion website or any other channel including third
                        party channels;
                      </div>
                      <div>
                        ii) republish material from the ICTLife Merchant
                        platform (including republication on another website);
                      </div>
                      <div>
                        iii) sell, rent or sub-license material from the
                        platform;
                      </div>
                      <div>
                        iv) show any material from the platform in public;
                      </div>
                      <div>
                        v) exploit the material from the platform for a
                        commercial purpose; or
                      </div>
                      <div>vi) redistribute material from the platform.</div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                Subject to the above clause and the other provisions of these
                terms and conditions, you may forward links to merchant profiles
                and related content on the platform and redistribute our
                promotional materials in print and electronic form to any
                person. You agree to take full responsibility and indemnify us
                from any liabilities arising from your distribution and/or
                redistribution of such material.
              </div>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    The ICTLife merchant platform may also contain links to
                    third party websites and other services that are not owned,
                    offered or controlled by us. Please exercise due care when
                    following such third party links since any resultant content
                    or claims are entirely the responsibility of such third
                    party website or service.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    During account registration, you may be asked to provide an
                    account identifier token, such as your phone number, an
                    email address or a username. You will also be required to
                    maintain an account security token that you may create
                    yourself(such as a password or PIN) or which may be
                    auto-generated by our system, such as a one-time
                    password(OTP). You agree to keep such account identifiers
                    and security tokens confidential for as long as they remain
                    valid for accessing your account, and to change the security
                    tokens from time to time and in the event that you suspect
                    or become aware of the disclosure of the security token to
                    another party.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    You shall be responsible for all activity on your ICTLife
                    platform account, including activity arising from your
                    failure to maintain the confidentiality of your account
                    access and security tokens. You are therefore advised to
                    take this matter seriously as you may be held liable for any
                    resultant loss or damage.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    The installation process and set-up of certain components of
                    the ICTlife Merchant platform, such as the mobile App, may
                    require that you grant us certain permissions on your
                    device. Most mobile devices provide you with information
                    about these permissions and you are advised to check your
                    device procedures should you have any questions on these
                    permissions. We will use such permissions and any data we
                    subsequently collect to provide ICTLife services, and as
                    published within the ICTLife Merchant platform privacy
                    policy.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    Your account shall be used exclusively by you and you shall
                    not transfer your account to any third party. If you
                    authorize any third party to manage your account on your
                    behalf this shall be at your own risk and responsibility.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    We reserve the right to suspend or restrict access to the
                    entire ICTLife Merchant platform, to areas of the platform
                    and/or to certain functionality of the platform. We may, for
                    example, limit access to the platform during technical
                    maintenance or other updates. You must not circumvent or
                    bypass, or attempt to circumvent or bypass, any access
                    restriction measures we may put on the platform.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    You may cancel your ICTLife platform account at any time by
                    contacting us as provided in the contact information section
                    of this document.
                  </div>
                </div>
              </div>
            </div>
            <div
              className={styles.subSection}
              id="usage-of-merchant-platform-website"
            >
              <h1>Usage of ICTLife Merchant platform website(s)</h1>
              <div>
                You may connect to an ICTLife Merchant platform website to:
              </div>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>view pages from such website in a web browser;</div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    download pages from the website for caching in a web
                    browser;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    print pages from the website for your own personal and
                    business, excluding bulk, systematic or excessive printing,
                    and within the provisions of these terms and conditions;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    stream audio and video files from our website using the
                    media player on our website or any third party media that we
                    may integrate into the website; and
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    use the ICTLife platform services by means of a web browser
                    or on your mobile device, subject to the other provisions of
                    these terms and conditions.
                  </div>
                </div>
              </div>
              <p>
                Except as expressly permitted above or in the other provisions
                of these terms and conditions, you must not download any
                material from the ICTLife Merchant platform website or save any
                such material to your computer.
              </p>
              <p>
                You may only use the ICTLife platform services for your own
                personal and business purposes in respect of facilitating
                legitimate commerce and trade of products or services on the
                platform.
              </p>
              <p>
                Except as expressly permitted by these general terms and
                conditions, you must not edit or otherwise modify any material
                on the website.
              </p>
            </div>
            <div className={styles.subSection} id="general-prohibitions">
              <h1>General prohibitions</h1>
              <p>You hereby agree NOT to:</p>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    use the ICTLife Merchant platform in any way that is
                    unethical, unlawful, illegal, fraudulent or harmful, or in
                    connection with any unlawful, illegal, fraudulent or harmful
                    purpose or activity;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    use the ICTLife Merchant platform in any way (or take any
                    action) that causes, or may cause, damage to the platform or
                    impairment of the performance, availability, accessibility,
                    integrity or security of the platform;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    hack or otherwise tamper with the ICTLife Merchant platform
                    or any of its components;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    probe, scan or test the vulnerability of the ICTLife
                    Merchant platform without our prior express written
                    permission;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    circumvent any authentication or security systems or
                    processes on or relating to the ICTLife merchant platform or
                    any of ICTLife products or services;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    use the ICTLife Merchant platform to copy, store, host,
                    transmit, send, use, publish or distribute any material
                    which consists of (or is linked to) any spyware, computer
                    virus, Trojan horse, worm, keystroke logger, rootkit or
                    other malicious computer software;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    impose an unreasonably large load on the ICTLife Merchant
                    platform resources (including bandwidth, storage capacity
                    and processing capacity);
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    decrypt or decipher, or attempt to decrypt or decipher, any
                    communications sent by or to the ICTLife Merchant platform
                    without our permission;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    conduct any systematic or automated data collection
                    activities (including without limitation scraping, data
                    mining, data extraction and data harvesting) on or in
                    relation to the ICTLife Merchant platform without our
                    express written consent;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    access or otherwise interact with the ICTLife Merchant
                    platform using any robot, spider or other automated means,
                    except for the purpose of search engine indexing;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    violate the directives set out in the robots.txt of an
                    ICTLife Merchant platform website or similar directive
                    instructions applicable on any ICTLife product;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    use data collected from or through the ICTLife Merchant
                    platform for any direct marketing activity (including
                    without limitation email marketing, SMS marketing,
                    telemarketing and direct mailing); or
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    take, or cause to be taken, any action that interferes with
                    the normal use and/or acceptable functionality of the
                    ICTLife Merchant platform or any of its components.
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.subSection} id="grant-of-rights">
              <h1>Your grant of rights to ICTLife to use your content</h1>
              <p>
                By uploading or otherwise submitting content onto the ICTLife
                merchant platform through any channel provided by us or a third
                party, and unless we indicate otherwise:
              </p>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    You represent and warrant that you own or otherwise control
                    all of the rights to the content that you post or publish;
                    that the content is accurate; that use of the content you
                    supply does not violate these terms and conditions and any
                    of our other policies and guidelines and will not cause
                    injury to any person or entity; and that you will indemnify
                    ICTLife for all claims resulting from content you supply.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    You grant us a nonexclusive, worldwide, royalty-free,
                    perpetual, irrevocable, and fully sub-licensable right to
                    use,reproduce, store, modify, adapt, publish, perform,
                    translate, create derivative works from, distribute, and
                    display such content across our marketing channels and any
                    existing or future media.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    You grant us and our existing and future sublicensees the
                    right to use the name that you submit in connection with
                    such content, if they choose.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    You hereby waive all your moral rights(including but not
                    limited to attribution and the integrity of works) in your
                    content to the maximum extent permitted by applicable law;
                    and you warrant and represent that all other moral rights in
                    your content have been waived to the maximum extent
                    permitted by applicable law.
                    <br />
                    <p>
                      <span className="note">Note: </span> Moral rights here
                      refers to the rights relating to “the connection between
                      artists and their works and creations”, and not the
                      “morals” as advocated in matters of behavioral ethics and
                      religion.
                    </p>
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    You grant to us the right to bring an action for
                    infringement of the rights licensed under clause 2 above.
                  </div>
                </div>
              </div>
              <p>
                ICTLife respects the intellectual property of others, and we
                would like to ensure that there is mutual regard and respect for
                intellectual property amongst all users on the platform. If you
                believe that your intellectual property rights have been
                infringed, please submit your complaint using the flagging and
                reporting capability provided within the context of the
                material, such a review, post or account profile, citing the
                relevant information as provided in the reporting procedure.
              </p>
              <p>
                You may also submit a written claim of intellectual property
                infringement to our contact address as supplied in the contact
                section of this document:
              </p>
              <p>Written claims must include:</p>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    A description of the intellectual property or work that you
                    claim has been infringed upon;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    A description of where the material that you claim is
                    infringing is located on the platform and preferably with a
                    link or printed representation to such material;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    A physical or electronic signature of the person authorized
                    to act on behalf of the owner of the intellectual property
                    interest;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    Your address, telephone number, and e-mail address, and
                    similar details of each, if any, intellectual property
                    owners you represent within the context of the claim being
                    filed with us;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    A statement by you that you have a good-faith interest and
                    belief that the disputed use is not authorized by the
                    copyright owner, its agent, or the law; and
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    A statement by you, made under penalty of perjury, or other
                    oath under a legally competent authority within applicable
                    jurisdiction, that the above information in your notice is
                    accurate and that you are the intellectual property owner or
                    an authorized representative of the respective owner(s).
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    Relevant documentation that may act as proof of ownership of
                    the intellectual property in question, including
                    physical/scanned copies of such documentation, electronic
                    attachments and links to similar resources.
                  </div>
                </div>
              </div>
              <p>
                We commit to respond quickly to the concerns of intellectual
                property rights owners about any alleged infringement, and we
                will terminate repeat infringers in appropriate circumstances.
              </p>
            </div>
            <div
              className={styles.subSection}
              id="community-interaction-guidelines"
            >
              <h1>Community Interaction guidelines</h1>
              <p>
                All interactions on the ICTLife Merchant platform shall be made
                in accordance with the ICTLife Community Interaction policy,
                which we may solely review from time to time and publish related
                changes or updates on our website. You will be duly notified of
                such changes or updates.
              </p>
              <h3>Content curation, reporting and related disputes</h3>
              <p>
                While we do not guarantee to keep the content on the entire
                platform appropriately and adequately curated at all times, we
                will endeavor to enforce our policies in regard to the
                acceptable content on the platform and its usage.
              </p>
              <p>
                Users of the platform are advised to flag and report any content
                that they deem unacceptable according to the provisions of these
                terms and conditions, or that potentially contravenes the spirit
                of the platform, including violating the rights of other users
                amongst other reasons.
              </p>
              <p>
                Whenever possible, we will provide actionable items, such as
                clickable “flag” buttons within the context of platform content
                , which users can use to report any concerning content they
                spot.
              </p>
              <p>
                Users may also contact us directly using the contact information
                provided in this document to report on concerning content on the
                platform. Such reports must contain:
              </p>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>Your address, telephone number, and e-mail address</div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    <p>
                      Clear reasons why you believe the cited content is in
                      conflict with any of our provisions, or is otherwise
                      concerning. Possible reasons non-exhaustively include:
                    </p>
                    <div className={styles.romanList}>
                      <div>
                        i) Infringement of intellectual property - see the
                        dedicated section above on related matters.
                      </div>
                      <div>
                        ii) Inappropriate material such as racist content,
                        nudity or similarly offensive material.
                      </div>
                      <div>
                        iii) Misleading information or misrepresentation with
                        malicious or illegitimate interests.
                      </div>
                      <div>
                        iv) Fraudulent or scamming content, including “seemingly
                        innocent clever schemes” and other illegal content.
                      </div>
                      <div>
                        v) Any other alarming or concerning reasons, which must
                        be clearly expressed.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p>
                We reserve the right (but not the obligation) to monitor,
                respond, edit, unpublish or delete any reported activity or
                content on the platform.
              </p>
            </div>
            <div
              className={styles.subSection}
              id="continuous-improvement-updates-and-upgrades"
            >
              <h1>Continuous improvement, updates and upgrades</h1>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    From time to time, we may offer updates and upgrades to the
                    ICTLife Merchant platform, in whole or in part, with the aim
                    of correcting errors (“fixing bugs”) or adding features
                    (“updates”), or replacing the platform with a new or
                    improved version (“upgrades”). For the continued enjoyment
                    of use of the platform, you will be required to constantly
                    install such updates and upgrades, which we will avail on
                    our website, through in-App notifications and/or through
                    third party stores.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    We will not require you to pay any extra fees in addition to
                    any license fees already paid to us within the agreed and
                    applicable duration of use of the platform in the event of
                    such updates or upgrades.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    Whenever we release the revised or improved versions of the
                    platform or its components, we reserve the right to
                    discontinue access, availability and support for the
                    previous versions of the platform, including such affected
                    components, in order to provide adequate level of service
                    and enhance security and data privacy mechanisms, amongst
                    other reasons.
                  </div>
                </div>
              </div>
            </div>
            <div
              className={styles.subSection}
              id="our-standpoint-on-data-privacy"
            >
              <h1>Our standpoint on Data Privacy</h1>
              <p>
                The privacy of your information, including personal information,
                business information, information about your usage of the App
                and other personally identifying information, is very important
                to us and shall be handled in accordance with the ICTLife
                Merchant platform privacy policy, which we may solely review
                from time to time and publish related changes or updates on our
                website. You will also be duly notified of such changes or
                updates as provided in the “Variations and updates” section of
                these general terms and conditions.
              </p>
            </div>
            <div
              className={styles.subSection}
              id="due-diligence-and-audit-rights"
            >
              <h1>Due diligence and audit rights</h1>
              <p>
                To fulfil our business goals and legal obligations, we may
                implement certain compliance programs and we reserve the right
                to perform due diligence checks on any user of the ICTLife
                Merchant platform and related services.
              </p>
              <p>
                You agree to provide to us or our legal representatives all such
                information, documentation and access to your business premises
                as may be required to verify your adherence to, and performance
                of your obligations under this agreement, or as otherwise
                required or provided by applicable law or regulation.
              </p>
            </div>
            <div
              className={styles.subSection}
              id="our-responsibility-as-provider-of-merchant-platform"
            >
              <h1>
                Our responsibility as the provider of the Merchant platform
              </h1>
              <p>
                While we will endeavor to ensure the merchant platform remains a
                sustainably progressive, legally observant and trusted center of
                prosperous commercial interaction between businesses and their
                customers:
              </p>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    We do not guarantee any commercial results concerning the
                    use of the ICTLife Merchant platform.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    <p>You acknowledge that:</p>
                    <div className={styles.romanList}>
                      <div>
                        i) we do not confirm the identity of all platform users,
                        check their credit worthiness or bona fides, or
                        otherwise vet them;
                      </div>
                      <div>
                        ii) we do not check, audit or monitor all information
                        contained in listings or any other content on the
                        platform;
                      </div>
                      <div>
                        iii) we are not party to any contract for the sale or
                        purchase of products and/or services advertised on the
                        platform;
                      </div>
                      <div>
                        iv) we are not involved in any transaction between a
                        buyer and a seller in any way, save that we facilitate a
                        trust-based platform for buyers and sellers;
                      </div>
                      <div>
                        v) we are not the agents for any buyer or seller on the
                        platform, and accordingly we will not be liable to any
                        person in relation to the offer for sale, sale or
                        purchase of any products or services advertised on the
                        platform; furthermore we are not responsible for the
                        enforcement of any contractual obligations arising out
                        of a contract for the sale or purchase of any products
                        or services on the platform and we will have no
                        obligation to mediate between the parties to any such
                        contract.
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    <p>We do not represent or warrant:</p>
                    <div className={styles.romanList}>
                      <div>
                        i) the completeness or accuracy of the information
                        published on the platform;
                      </div>
                      <div>
                        ii) that the material on the platform is up to date;
                      </div>
                      <div>
                        iii) that the platform will operate without fault or
                        failure; or
                      </div>
                      <div>
                        iv) that the platform or any service published on the
                        platform will remain available.
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    We reserve the right to discontinue or alter any or all of
                    the ICTLife Merchant platform services, and to stop
                    publishing the platform, at any time in our sole discretion
                    without notice or explanation; and you will not be entitled
                    to any compensation or other payment upon the discontinuance
                    or alteration of any ICTLife Merchant platform services, or
                    if we stop publishing the platform altogether.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    As the provider of the platform, we reserve the right to
                    curate the content that is displayed on the merchant
                    platform and organize it on our marketplaces. We reserve the
                    right (but not the obligation) to edit, delete, suspend
                    content that in our sole discretion goes against the terms
                    and conditions. We additionally reserve the right to suspend
                    or delete accounts which are found to be violating the terms
                    and conditions herein. You may appeal the decision to
                    suspend or terminate your account or remove/edit your posts
                    through our dispute resolution process.
                  </div>
                </div>
              </div>
            </div>
            <div
              className={styles.subSection}
              id="disclaimer-of-warranties-and-limitation-of-liability"
            >
              <h1>Disclaimer of warranties and limitation of liability</h1>
              <p>
                As part of our mission, we will endeavor to deliver our
                technology and the related user experience in the best state.
              </p>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    We will ensure that the platform’s components are well
                    tested to the best of our ability and while we do not
                    guarantee that the platform will be 100% free of errors, we
                    will strive to have as thorough a testing process as
                    possible and feasible at the time of release of the platform
                    or its components.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    We will do our best to ensure we adequately address the
                    security risks arising from the features in the platform,
                    including implementing the related countermeasures. While
                    100% security is impossible, we will do our best to keep
                    improving the platform while incorporating user feedback as
                    reasonably (and feasibly) as possible to address arising
                    challenges or concerns in the user experience of our
                    products.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    We will endeavor to deliver the platform and its components
                    in the state that best delivers and serves your intended
                    purposes while respecting the intellectual property rights
                    of others. We however, and understandably do not guarantee
                    the merchantability or fitness-for-purpose of the platform
                    to your specific needs. We are however open and committed to
                    listen and as feasible, work with you to improve the
                    platform and meet your needs as closely as possible.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    We would like our users to understand and appreciate that we
                    still operate within technological and human limitations and
                    as such, while we will put in our best efforts, we do not
                    guarantee that our product development procedures and the
                    results will be 100% correct and/or free from errors which
                    may therefore sometimes, and inevitably, produce undesirable
                    effects during the use of the platform.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    You therefore agree to not hold us liable for any direct or
                    indirect loss or damage incurred as a result of the
                    malfunction, irresponsiveness, unavailability or any other
                    undesirable effect or operation of the ICTLife Merchant
                    platform.
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.subSection} id="indemnification">
              <h1>Indemnification</h1>
              <p>
                You hereby indemnify us, and undertake to keep us indemnified,
                against:
              </p>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    any and all losses, damages, costs, liabilities and expenses
                    (including without limitation legal expenses and any amounts
                    paid by us to any third party in settlement of a claim or
                    dispute) incurred or suffered by us and arising directly or
                    indirectly out of your use of the platform or any breach by
                    you of any provision of these general terms and conditions
                    or any other ICTLife policies, codes or guidelines; and
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    any VAT liability or other tax liability that we may incur
                    in relation to any sale, supply or purchase made through the
                    platform, where that liability arises out of your failure to
                    pay, withhold, declare or register to pay any VAT or other
                    tax properly due in any jurisdiction.
                  </div>
                </div>
              </div>
            </div>
            <div
              className={styles.subSection}
              id="discontinuation-of-this-agreement"
            >
              <h1>Discontinuation of this agreement</h1>
              <p>
                We understand that under certain circumstances, you may no
                longer be willing to continue using the ICTLife Merchant
                platform, or to otherwise be bound by these terms and
                conditions. In such cases, we require that you, where
                applicable, uninstall the Merchant App and delete all related
                files from all devices on which you have installed the App or
                otherwise used to access the Merchant platform.
              </p>
              <p>
                We may also terminate this agreement with you in the event that
                (in our sole discretion and judgement,) we reasonably conclude
                that we no longer wish to continue the agreement. This is, for
                example, and without limitation, in the event of your
                unacceptable violation of these terms and conditions, or your
                violation of any of the other ICTLife guidelines or policies,
                amongst other reasons which we may choose to disclose to you or
                not.
              </p>
              <p>We will upon the termination of these terms and conditions:</p>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    NOT be obliged to make any compensation to you whatsoever,
                    or refund any license fees previously paid to us for your
                    use of the platform and related services;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    NOT be obliged to transfer historical data from your account
                    profile and related activity onto any other account on our
                    platform;
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    Henceforth handle your data retained on our systems in
                    accordance with our privacy policy and related provisions.
                  </div>
                </div>
              </div>
            </div>
            <div
              className={styles.subSection}
              id="severability-of-provisions-in-these-terms-and-conditions"
            >
              <h1>Severability of provisions in these terms and conditions</h1>
              <h3>For clarity and the avoidance of doubt:</h3>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    If a provision of these general terms and conditions is
                    determined by any court or other competent authority to be
                    unlawful and/or unenforceable, the other provisions will
                    continue in effect.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    If any unlawful and/or unenforceable provision of these
                    general terms and conditions would be lawful or enforceable
                    if part of it were deleted, that part will be deemed to be
                    deleted, and the rest of the provision will continue in
                    effect.
                  </div>
                </div>
              </div>
            </div>
            <div
              className={styles.subSection}
              id="transfer-of-rights-or-assignment"
            >
              <h1>Transfer of rights/Assignment</h1>
              <p>
                You agree that we may also transfer, assign, subcontract or
                otherwise deal with any of our rights or obligations under these
                terms and conditions to a third party, such as in the event of a
                change or transfer of our organizational ownership. You will be
                notified in the event of such changes, and we will endeavor to
                ensure that such changes are congruent and in alignment with
                these terms and conditions for our continued and progressive
                relationship.
              </p>
              <p>
                You may not, without our prior written consent, transfer,
                assign, sub-contract or otherwise deal with any of your rights
                and/or obligations under these general terms and conditions.
              </p>
            </div>
            <div
              className={styles.subSection}
              id="third-party-rights-and-consent"
            >
              <h1>Third party rights and consent</h1>
              <p>
                A contract under these general terms and conditions is for our
                benefit and your benefit; it is neither intended to benefit nor
                be enforceable by any third party.
              </p>
              <p>
                The exercise of the parties’ rights under a contract under these
                general terms and conditions is not subject to the consent of
                any third party.
              </p>
            </div>
            <div
              className={styles.subSection}
              id="resolution-of-disputes-and-applicable-law"
            >
              <h1>Resolution of disputes and applicable law</h1>
              <div className={styles.list}>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    These terms and conditions shall be governed by the laws of
                    the Republic of Kenya and subject to item (b) below, the
                    parties irrevocably submit to the Courts of law in Kenya.
                  </div>
                </div>
                <div className={styles.listItem}>
                  <div className={styles.bullet}>
                    <img
                      src="/images/landing-page/orange-bullet.svg"
                      alt="orange bullet point"
                    />
                  </div>
                  <div>
                    In the event of a dispute, the parties to these terms and
                    conditions shall prefer to settle the dispute amicably
                    through negotiation in good faith. In the event that the
                    dispute remains unsettled for a duration of sixty(60) days,
                    the matter shall be referred to an arbitrator under the
                    rules of the Arbitration (Amendment) Act 1995 of Kenya or
                    any statutory modification or re-enactment for the time
                    being in force, such arbitrator to be appointed by agreement
                    of both parties, and in the absence of agreement within
                    fourteen(14) days of notification of the dispute by either
                    party to the other then on the application of any one party
                    to the Chairman of the Kenyan Chapter of the Chartered
                    institute of Arbitrators and the decision of such arbitrator
                    shall be final and binding on the parties hereto.
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.subSection} id="contact-information">
              <h1>Our contact information</h1>
              <p>
                For any queries, requests and feedback related to these terms
                and conditions, please send us an email addressed to
                info@ictlife.com, or contact us by postal mail sent to the
                ICTLife address below:
              </p>
              <div>
                <div>The Management,</div>
                <div>Ideas Come To Life Ltd, Block A-7, Rehema Place,</div>
                <div>Junction of Ngong Rd and Ring Road Kilimani,</div>
                <div>Nairobi, Kenya</div>
                <div> P.O. BOX 13908-00800 Westlands, Nairobi, Kenya</div>
              </div>
              <div>
                <div>
                  <b>Last Modified: 21st October, 2020</b>
                </div>
                <div>
                  <b>Effective: 30th October, 2020</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </Fragment>
  );
}
